import type { ReactNode } from "react";
import { cn } from "cn";
import { Card } from "@/components/ui/card.tsx";

export interface FilterToolbarShellProps {
    children: ReactNode;
    className?: string;
}

export function FilterToolbarShell({ children, className }: FilterToolbarShellProps) {
    return (
        <Card className={cn("gap-0 overflow-hidden py-0 shadow-none", className)}>
            <div className="bg-muted/20">{children}</div>
        </Card>
    );
}
